import * as React from "react";
import InternalLink from "../Navigation/InternalLink/InternalLink";
import { StyledMaterialChip } from "./StyledMaterialChip";
// eslint-disable-next-line no-restricted-imports
import ToolTip, { ToolTipContent } from "../../primitiveComponents/dataDisplay/ToolTip";
import navigationChipStyles from "./NavigationChip.less";

export interface NavigationChipProps {
    to: string;
    accessibleName: string;
    description?: string | ToolTipContent;
}

export const NavigationChip: React.FC<NavigationChipProps> = ({ to, accessibleName, children, description }) => {
    return (
        <InternalLink to={to} accessibleName={accessibleName}>
            <StyledMaterialChip className={navigationChipStyles.clickable} label={<ToolTip content={<span>{description || children}</span>}>{children}</ToolTip>} />
        </InternalLink>
    );
};

export default NavigationChip;
